module.exports = __webpack_public_path__ + "static/media/micInactive.e85f934c.svg";